export default "__VITE_ASSET__DL6iQN$v__"